export default defineNuxtRouteMiddleware(async (to, _from) => {
    const { fetchUser, setUser } = useDirectusAuth();
    const user = useDirectusUser();

    if (!user.value) {
        /*try {
            const tryFetchUser = await fetchUser();
            if (tryFetchUser.value) {
                setUser(tryFetchUser.value);
            } else return navigateTo({ name: 'members-login' });
        } catch (error) {
            return navigateTo({ name: 'members-login' });
        }*/
    }

    if (!user.value) {
        const user = await fetchUser();
        setUser(user.value);
    }
    if (!user.value) {
        return navigateTo({ name: 'members-login' })
    }
});